import axios from "axios";

const state = {};
const actions = {
  COWORK_REST_ALL_ACTION({ state, commit, dispatch }, reqData) {
    let url = reqData.url; //url 정보
    let method = reqData.method; // get or post
    let params = reqData.params;
    if (method === "post") {
      return axios
        .post(url, params)
        .then(res => res)
        .catch(err => console.log(err));
    } else {
      return axios
        .get(url, params)
        .then(res => res.data)
        .catch(err => console.log(err));
    }
  },
  COWORK_REST_SIMPLE_ACTION({ state, commit, dispatch }, reqData) {
    let url = reqData.url; //url 정보
    let method = reqData.method; // get or post
    let params = reqData.params;
    if (method === "post") {
      return axios
        .post(url, params)
        .then(res => res.data)
        .catch(err => console.log(err));
    } else {
      return axios
        .get(url, params)
        .then(res => res.data)
        .catch(err => console.log(err));
    }
  },
  async ASYNC_COWORK_REST_SIMPLE_ACTION({ state, commit, dispatch }, reqData) {
    let url = reqData.url; //url 정보
    let method = reqData.method; // get or post
    let params = reqData.params;
    if (method === "post") {
      return await axios
        .post(url, params)
        .then(res => res.data)
        .catch(err => console.log(err));
    } else {
      return await axios
        .get(url, params)
        .then(res => res.data)
        .catch(err => console.log(err));
    }
  },
  /*  */
  COWORK_REST_ACTION({ state, commit, dispatch }, reqData) {
    let url = reqData.url; //url 정보
    let method = reqData.method; // get or post
    let req = reqData.req;
    if (method === "post") {
      return axios
        .post(url, req)
        .then(res => res.data)
        .catch(err => console.log(err));
    } else {
      return axios
        .get(url, req)
        .then(res => res.data)
        .catch(err => console.log(err));
    }
  },
  /*  */
  async ASYNC_COWORK_REST_ACTION({ state, commit, dispatch }, reqData) {
    let url = reqData.url; //url 정보
    let method = reqData.method; // get or post
    let req = reqData.req;
    if (method === "post") {
      return await axios
        .post(url, req)
        .then(res => res.data)
        .catch(err => console.log(err));
    } else {
      return await axios
        .get(url, req)
        .then(res => res.data)
        .catch(err => console.log(err));
    }
  }
};
const mutations = {};
const getters = {};

export default { state, actions, mutations, getters, namespaced: true };



// WEBPACK FOOTER //
// ./src/js/store/module/common/restAction.js